import { NavLink } from "react-router-dom";
import "./inner-page-navigation.scss";
import { getValue } from "@utils/lodash";
import Radio from "@components/common/Forms/Radio";

export default function ReportTabNavigation(props: any) {
  const { isAscending, setIsAscending } = props;
  return (
    <div className="common-sticky-header report_details_navigation_wrapper">
      <section className="inner-page-navigation-with-back-cta-buttons position-relative ">
        <div
          className="container-fluid d-flex justify-content-between align-items-center"
          style={{ width: "100%" }}
        >
          <ul className="inner-page-navigation-with-back-cta-buttons__navigation_left_temp d-inline-flex position-absolute cursor-pointer">
            <li
              className={`position-relative inner-page-navigation-with-back-cta-buttons__nav-list-item active`}
            >
              Expenses
              {getValue(props, `length`, 0) > 0 && (
                <p className="report_count">{getValue(props, `length`, "")}</p>
              )}
            </li>
          </ul>

          <div
            style={{
              marginLeft: "auto",
              display: "flex",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <span className="" style={{ fontSize: "14px", marginRight: "8px" }}>
              Order by Expense No:
            </span>
            <span style={{ fontSize: "14px", color: "#555" }}> Asc</span>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                transform: "translateY(-4px)",
              }}
            >
              <Radio
                onChange={(e: any) => {
                  setIsAscending((r: boolean) => !r);
                }}
                value={isAscending}
                checked={isAscending}
                type={"boolean"}
                placeholder={``}
                label={``}
                disabled={false}
                name={""}
                maxLength={0}
                validator={undefined}
                mandatory={false}
                hideLabel={true}
                validatoryType={""}
              />
            </div>

            <span style={{ fontSize: "14px", color: "#555" }}>Desc</span>
          </div>
        </div>
      </section>
    </div>
  );
}
